import React, { useState } from 'react';
import { IconCheck, IconChevronDown } from '@tabler/icons-react';
export interface ChecklistItem {
  id: string;
  text: string;
  completed: boolean;
}
interface ChecklistCardProps {
  title: string;
  items: ChecklistItem[];
  categoryColor?: string;
  defaultExpanded?: boolean;
  onToggleItem?: (itemId: string) => void;
}
export function ChecklistCard({
  title,
  items,
  categoryColor = '#B0EC9C',
  defaultExpanded = true,
  onToggleItem
}: ChecklistCardProps) {
  // We keep local state for expansion, but checked state comes from props (items)
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  // Calculate completed count from props
  const completedCount = items.filter(item => item.completed).length;
  return <div className="bg-white border border-yeppy-text border-opacity-10 rounded-yeppy overflow-hidden" data-id="element-103">
      {/* Accent bar with category color */}
      <div className="h-1" style={{
      backgroundColor: categoryColor
    }} data-id="element-104" />

      {/* Header - Always visible, clickable to toggle */}
      <button onClick={() => setIsExpanded(!isExpanded)} className="w-full p-5 flex items-center justify-between transition-colors" data-id="element-105">
        <div className="flex items-center justify-between" data-id="element-106">
          <h3 className="font-rubik text-yeppy-text font-[500] text-[15px]" data-id="element-107">
            {title}
          </h3>
          <IconChevronDown className={`w-5 h-5 text-yeppy-text text-opacity-40 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`} stroke={1.5} data-id="element-108" />
        </div>
      </button>

      {/* Checklist items - Collapsible */}
      {isExpanded && <div className="px-5 pb-5" data-id="element-109">
          <ul className="space-y-3" role="list" data-id="element-110">
            {items.map(item => <li key={item.id} className="flex items-start" data-id="element-111">
                <div className={`w-5 h-5 rounded flex items-center justify-center flex-shrink-0 transition-colors ${item.completed ? 'bg-yeppy-text text-white' : 'border-2 border-yeppy-text border-opacity-20'}`} data-id="element-112">
                  {item.completed && <IconCheck className="w-3.5 h-3.5" stroke={2.5} data-id="element-113" />}
                </div>
                <span className={`font-poppins text-sm text-yeppy-text leading-relaxed transition-all duration-200 ${item.completed ? 'line-through opacity-50' : 'opacity-80'}`} data-id="element-114">
                  {item.text}
                </span>
              </li>)}
          </ul>
        </div>}
    </div>;
}